import { useEffect } from "react";

const SITE = "https://gobrivio.com";

// Lightweight per-route metadata for a CRA SPA (no react-helmet).
// Sets document.title, meta description, and canonical link on mount.
export function usePageMeta({ title, description, canonicalPath }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }

    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      const path = canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`;
      link.setAttribute("href", `${SITE}${path}`);
    }
  }, [title, description, canonicalPath]);
}
